<template>
  <AdminLayout>
    <template #content>
      <UsageManualPage
        title="Guide utilisateur Suite241"
        subtitle="Un guide complet et pédagogique pour gérer les produits, achats, ventes, stock, caisse, inventaires, rapports et bonnes pratiques de votre boutique."
        :items="items"
        :show-toc-card="false"
      />
    </template>
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/layouts/AdminLayout.vue';
import UsageManualPage from '@/components/UsageManualPage.vue';
import { adminManualItems } from '@/support/usageManualContent';

export default {
  name: 'AdminManualView',
  components: {
    AdminLayout,
    UsageManualPage,
  },
  data() {
    return {
      items: adminManualItems,
    };
  },
};
</script>
